/**
 * Email Protection
 * Obfuscates email address from scrapers while keeping it accessible to users
 */

function initEmailProtection() {
    const contactLink = document.getElementById('contact-email');
    
    if (!contactLink) return;
    
    // Obfuscated email parts (reversed and encoded)
    const user = 'olleh'; // 'hello' reversed
    const domain = 'ue.dliubagoy'; // 'yogabuild.eu' reversed
    
    // Construct the email
    const email = `${user.split('').reverse().join('')}@${domain.split('').reverse().join('')}`;
    
    // Set the mailto link
    contactLink.href = `mailto:${email}`;
    
    // Optional: Update the text content if you want to show the email
    // contactLink.textContent = email;
}

// Auto-initialize on DOM ready
document.addEventListener('DOMContentLoaded', initEmailProtection);
